<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 13,
            title: "CLAVES DE PEDIMENTO",
            columns: ["clave", "descripcion", "supuestos", "categoria", "actions"],
            options: {
                filterable: ["clave", "descripcion", "supuestos", "categoria"],
                sortable: ["clave", "descripcion", "supuestos", "categoria"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    supuestos: "Supuestos",
                    categoria: "Categoría",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Supuestos: "supuestos",
                Categoría: "categoria"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                supuestos: "supuestos",
                categoria: "categoria"
            },
            camposLayout: [{
                clave: "[Clave de Pedimento]",
                descripcion: "[Descripción]",
                supuestos: "[Supuestos]",
                categoria: "[Categorías]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                supuestos: "",
                categoria: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                },
                supuestos: {
                    requiered: true,
                    label: "Supuestos",
                    value: "",
                    maxlen: 200
                },
                categoria: {
                    requiered: true,
                    label: "Categoría",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>